import { Directive, HostListener, Input, Output, ElementRef, EventEmitter } from "@angular/core";
import { HIGHLIGHTED, DISABLED, IMenuItem } from "nd-gui/core";
import { UP_ARROW, DOWN_ARROW, SPACE, HOME, ENTER, END } from "nd-common";

@Directive({
	selector: "[nd-menu-nav]"
} )
export class ndMenuNavigationDirective
{
	@Input("nd-menu-nav") menuIsActive: boolean;
	constructor(private el: ElementRef) { }

	@HostListener( "keydown", ["$event"] )
	public keyupListener( event: KeyboardEvent )
	{
		if ( !this.menuIsActive ) { return; }
		
		let currentElement: Element = this.el.nativeElement.querySelector( ".highlighted" );

		if ( event.keyCode == UP_ARROW )
		{
			this.previousSibling( currentElement );
			return;
		}
		if ( event.keyCode == DOWN_ARROW )
		{
			this.nextSibling( currentElement );
			return;
		}
		if ( event.keyCode == ENTER || event.keyCode == SPACE )
		{
			return;
		}
		if ( event.keyCode == HOME )
		{
			this.setFirstChild();
		}
		if ( event.keyCode == END )
		{
			this.setLastChild();
		}
	}

	private nextSibling( currentElement: Element ): void
	{
		if ( currentElement )
		{
			currentElement.classList.remove( HIGHLIGHTED );
			let nextSibling: Element = currentElement.nextElementSibling;
			if ( nextSibling )
			{
				if ( nextSibling.classList.contains( DISABLED ) )
				{
					this.nextSibling( nextSibling );
				}
				else
				{
					nextSibling.classList.add( HIGHLIGHTED );
					( nextSibling as HTMLElement ).focus();
				}
			} else
			{
				this.setFirstChild();
			}
		}
		else
		{
			this.setFirstChild();
		}
	}

	private setLastChild(): void
	{
		let lastLi: HTMLLIElement = this.el.nativeElement.querySelector( "li:last-child" );
		lastLi.classList.add( HIGHLIGHTED );
		lastLi.focus();
	}

	private previousSibling( currentElement: Element ): void
	{
		if ( currentElement )
		{
			currentElement.classList.remove( HIGHLIGHTED );
			let previousSibling: Element = currentElement.previousElementSibling;
			if ( previousSibling )
			{
				if ( previousSibling.classList.contains( DISABLED ) )
				{
					this.previousSibling( previousSibling );
				}
				else
				{
					previousSibling.classList.add( HIGHLIGHTED );
					( previousSibling as HTMLElement ).focus();
				}
			} else
			{
				this.setLastChild();
			}
		}
		else
		{
			this.setLastChild();
		}
	}

	private setFirstChild(): void
	{
		let firstLi: HTMLLIElement = this.el.nativeElement.querySelector( "li:first-child" );
		firstLi.classList.add( HIGHLIGHTED );
		firstLi.focus();
	}
}

@Directive( {
	selector: "[nd-menu-item]"
} )
export class ndMenuListItemDirective
{
	@Input("nd-menu-item") item: IMenuItem<any>;
	@Output( "selected" ) itemSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
	constructor( private el: ElementRef ) { }

	@HostListener( "mouseenter" )
	mouseEnterHandler()
	{
		//	Remove the old highlight
		let previouslyHighlighted: Element = ( this.el.nativeElement as HTMLLIElement ).parentElement.querySelector( "." + HIGHLIGHTED );
		if ( previouslyHighlighted )
		{
			previouslyHighlighted.classList.remove( HIGHLIGHTED );
		}
		this.el.nativeElement.classList.add( HIGHLIGHTED );
	}

	@HostListener( "mouseleave" )
	mouseLeaveHandler()
	{
		this.el.nativeElement.classList.remove( HIGHLIGHTED );
	}

	@HostListener( "keydown", ["$event"] ) 
	keyEventListener( $event: KeyboardEvent )
	{
		if ( $event.keyCode == ENTER || $event.keyCode == SPACE )
		{
			this.executeCommand( this.item, $event );
		}
	}
	@HostListener( "click", ["$event"] )
	clickEventHandler( $event: MouseEvent )
	{
		this.executeCommand( this.item, $event );
	}

	private executeCommand(item: IMenuItem<any>, $event: Event ): void
	{
		if ( item.disabled ) { return; }
		if(item.command){
		item.command.call(this, item, $event);
		}
		this.itemSelected.emit( true );
		$event.stopPropagation();
	}
}
